import { apiEnvironment } from '../smoothr-web-app-core/environments/apiEnvironment';

export const customerGroup = 'dominos_switzerland';

const supportEmail = {
	[customerGroup]: 'la-cour-des-saveurs-cv@smoothr.de',
};
const firebaseConfig = {
	[customerGroup]: {
		apiKey: 'AIzaSyBXTTMDSbE6P_Dq8S-BtmxlOIQoXB1epZE',
		authDomain: 'versaille-f289d.firebaseapp.com',
		projectId: 'versaille-f289d',
		storageBucket: 'versaille-f289d.firebasestorage.app',
		messagingSenderId: '797769042602',
		appId: '1:797769042602:web:c731ed52e13bc9acadded3',
	},
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyAUJ0yCbuGUs9lDKehj-VGlD0oeU3XO__A',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	countryList: ['ch'],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup + '-dev',
	allergens_link: '',
	...apiEnvironment,
	hasRecommendations: true,
	hjid: 5035140,
	masterVenue: '695b6c5b23dc233692bebf37',
	menuVenue: '69d8a7a2b49e245793b9a916',
	adyenEnvironment: 'test',
};
